import React, { useState } from "react";
import Frame1 from "./components/Frame1/Frame1";
import Frame2 from "./components/Frame2/Frame2";
import Frame3 from "./components/Frame3/Frame3";
import "./Home.scss";
import { Notification } from "@netapp/bxp-design-system-react";

const Home = () => {
  const [notification, setNotification] = useState({
    visible: false,
    message: "",
    type: "success",
  });

  return (
    <div className="homeFrame">
      {notification.visible && (
        <Notification type={notification.type}>
          {notification.message}
        </Notification>
      )}
      <Frame1 />
      <Frame2 notification={notification} setNotification={setNotification} />
      <Frame3 />
    </div>
  );
};

export default Home;